import classNames from "classnames"
import type {
  ComponentProps,
  Ref,
} from "react"
import {
  forwardRef,
  useLayoutEffect,
} from "react"

import styles from "./Input.module.scss"
import { useInputIconButtonContext } from "./InputIconButtonContext"
import { IconButton } from "src/buttons"

enum PlacementPreset {
  start = "inputIconButtonStart",
  end = "inputIconButtonEnd",
}

type PlacementPresetKey = keyof typeof PlacementPreset

export type Props = ComponentProps<typeof IconButton> & {
  placementPreset: PlacementPresetKey;
}

export const InputIconButton = forwardRef<HTMLButtonElement, Props>(
  function InputIconButton(props: Props, propRef: Ref<HTMLButtonElement>) {
    const {
      placementPreset,
      stylePreset = "withoutBackground",
      ...iconButtonProps
    } = props

    const {
      setHasStartIcon,
      setHasEndIcon,
    } = useInputIconButtonContext()

    useLayoutEffect(
      () => {
        if (placementPreset === "start") {
          setHasStartIcon(true)
          return () => setHasStartIcon(false)
        }

        if (placementPreset === "end") {
          setHasEndIcon(true)
          return () => setHasEndIcon(false)
        }
      },
      [
        placementPreset,
        setHasStartIcon,
        setHasEndIcon,
      ],
    )

    const className = classNames(
      props.className,
      styles[PlacementPreset[placementPreset]],
    )

    return (
      <IconButton
        {...iconButtonProps}
        stylePreset={stylePreset}
        className={className}
        ref={propRef}
      />
    )
  },
)
